import React from "react";
import Plot from "react-plotly.js";

const PlotlyChart = ({ graphDataString }) => {
  let graphData;
  try {
    graphData = JSON.parse(graphDataString);
  } catch (error) {
    return <div>Error parsing graph data: {error.message}</div>;
  }

  if (!graphData.data || !graphData.layout) {
    return <div>Invalid graph data format.</div>;
  }
  const updatedLayout = {
    ...graphData.layout,
    margin: { t: 60, b: 60, l: 60, r: 60 },
  };

  return (
    <div className="chart-container">
    <Plot
        data={graphData.data}
        layout={updatedLayout}
        useResizeHandler
        style={{ width: "100%", height: "100%" }}
    />
    </div>
  );
};

export default PlotlyChart;
